/**
 * https://www.npmjs.com/package/react-multi-select-component
 */
import { MultiSelect, Option } from "react-multi-select-component";
import { FormItemContainer, FormItemProps } from "./FormItemContainer";

export type FormMultiSelectProps<T> = FormItemProps<T> & {
  options: T[];
  optionKey: (t: T) => string;
  optionLabel: (t: T) => string;
  disabled?: boolean;
  value: T[] | null;
  onChange: (value: T[]) => void;
};

const getOption = <T,>(args: { option: T; optionKey: (t: T) => string; optionLabel: (t: T) => string }): Option => {
  return {
    value: args.optionKey(args.option),
    label: args.optionLabel(args.option),
    key: args.optionKey(args.option),
  };
};

const getOptions = <T,>(props: FormMultiSelectProps<T>): Option[] => {
  return props.options.map((option) => {
    return getOption({ ...props, option });
  });
};

const getValue = <T,>(props: FormMultiSelectProps<T>): Option[] => {
  if (!props.value) return [];
  return props.value.map((option) => {
    return getOption({ ...props, option });
  });
};

const getSelection = <T,>(props: FormMultiSelectProps<T>, value: Option[]): T[] => {
  if (!value) return [];
  return (
    value
      // filter selected items
      .map((option) => {
        return props.options.find((o) => props.optionKey(o) === option.value);
      })
      // remove undefined
      .filter((item): item is T => !!item)
  );
};

export const FormMultiSelect = <T,>(props: FormMultiSelectProps<T>) => {
  return (
    <FormItemContainer {...props}>
      <MultiSelect
        options={getOptions(props)}
        value={getValue(props)}
        onChange={(value: Option[]) => props.onChange(getSelection(props, value))}
        labelledBy="Select"
      />
    </FormItemContainer>
  );
};
